import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { LocationAutocompleteInput } from '../../../components';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRef } from 'react';
import css from './LocationField.module.css';
const identity = v => v;

const LocationField = props => {
  const [location, setLocation] = useState(null);
  const inputRef = useRef(null);
  const intl = useIntl();

  return (
    <FinalForm
      onSubmit={() => {}}
      render={() => {
        return (
          <div>
            <label htmlFor={'location'}>
              <FormattedMessage id="Cappa.filters.locationLabel" defaultMessage={'Location'} />
            </label>
            <Field
              name="location"
              format={identity}
              render={({ input, meta }) => {
                const { onChange, ...restInput } = input;
                const searchOnChange = value => {
                  onChange(value);
                  setLocation(value);
                  if (value.selectedPlace) {
                    props.setFilters({
                      location: value.selectedPlace,
                    });
                  }
                };
                return (
                  <LocationAutocompleteInput
                    isFilterPanel
                    iconClassName={css.desktopIcon}
                    inputClassName={css.desktopInput}
                    predictionsClassName={css.desktopPredictions}
                    predictionsAttributionClassName={css.mobilePredictionsAttribution}
                    placeholder={intl.formatMessage({ id: 'TopbarSearchForm.placeholder' })}
                    closeOnBlur={true}
                    inputRef={inputRef}
                    input={{ ...restInput, onChange: searchOnChange }}
                    meta={meta}
                  />
                );
              }}
            />
          </div>
        );
      }}
    />
  );
};

export default LocationField;
